import Component from '../../common/Component';
import ItemList from '../../common/utils/ItemList';
import listItems from '../../common/helpers/listItems';

/**
 * The `DiscussionHero` component displays the hero on a discussion page.
 *
 * ### attrs
 *
 * - `discussion`
 */
export default class DiscussionHero extends Component {
  view() {
    return m("header", {
      className: "Hero DiscussionHero"
    }, m("div", {
      className: "container"
    }, m("ul", {
      className: "DiscussionHero-items"
    }, listItems(this.items().toArray()))));
  }

  /**
   * Build an item list for the contents of the discussion hero.
   *
   * @return {ItemList<import('mithril').Children>}
   */
  items() {
    const items = new ItemList();
    const discussion = this.attrs.discussion;
    const badges = discussion.badges().toArray();
    if (badges.length) {
      items.add('badges', m("ul", {
        className: "DiscussionHero-badges badges"
      }, listItems(badges)), 10);
    }
    items.add('title', m("h1", {
      className: "DiscussionHero-title"
    }, discussion.title()));
    return items;
  }
}
flarum.reg.add('core', 'forum/components/DiscussionHero', DiscussionHero);